import React, { useCallback } from 'react';

import FilterButton from '@adsk/alloy-react-filter-button';

import SearchFilterButton from './components/SearchFilterButton';
import { useCollection } from './providers/CollectionProvider';
import { useSearchPanel } from './providers/SearchPanelProvider';

const SheetCustomFilterButton = ({ filters, setFilters, ...rest }) => {
  const { isFeatureEnabled: enableCollectionFeature } = useCollection();
  const { resetSearchPanel } = useSearchPanel();

  const clearFilters = useCallback(() => {
    setFilters({});
    resetSearchPanel();
  }, [setFilters, resetSearchPanel]);

  return enableCollectionFeature ? (
    <SearchFilterButton
      {...rest}
      filters={filters}
      clearFilters={clearFilters}
    />
  ) : (
    <FilterButton
      {...rest}
      style={{
        marginLeft: 12,
      }}
    />
  );
};

export default SheetCustomFilterButton;
